// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  partId: __t.u64().primaryKey().name("part_id"),
  worldId: __t.u64().name("world_id"),
  linksetId: __t.u64().name("linkset_id"),
  primType: __t.string().name("prim_type"),
  meshRef: __t.string().name("mesh_ref"),
  sourceAssetId: __t.u64().name("source_asset_id"),
  modelAssetId: __t.u64().name("model_asset_id"),
  posX: __t.f32().name("pos_x"),
  posY: __t.f32().name("pos_y"),
  posZ: __t.f32().name("pos_z"),
  rotX: __t.f32().name("rot_x"),
  rotY: __t.f32().name("rot_y"),
  rotZ: __t.f32().name("rot_z"),
  rotW: __t.f32().name("rot_w"),
  scaleX: __t.f32().name("scale_x"),
  scaleY: __t.f32().name("scale_y"),
  scaleZ: __t.f32().name("scale_z"),
  shapeJson: __t.string().name("shape_json"),
  materialJson: __t.string().name("material_json"),
  phantom: __t.bool(),
  physics: __t.bool(),
  landImpact: __t.u16().name("land_impact"),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
});
